import createInfoBarMessageViewStateFactory from './createInfoBarMessageViewStateFactory';
import { getReadHostItemIndex } from 'owa-addins-core';
import * as ReadInfoBarHandlers from 'owa-mail-reading-pane-store/lib/utils/infoBarHandlers';
export var addNotificationMessage = function (viewState) { return function (messageId) {
    ReadInfoBarHandlers.infoBarAddHandler(viewState)(messageId, createInfoBarMessageViewStateFactory(getReadHostItemIndex(viewState.itemId), messageId, removeNotificationMessage(viewState)));
}; };
export var removeNotificationMessage = function (viewState) { return function (messageId) {
    ReadInfoBarHandlers.infoBarRemoveHandler(viewState)(messageId);
}; };
export var getNotificationMessageIds = function (viewState) { return function () {
    return ReadInfoBarHandlers.infoBarGetIdsHandler(viewState)();
}; };
//# sourceMappingURL=ReadNotificationMessageAdapter.js.map